module.exports = __webpack_public_path__ + "img/onboarding-decoration-2.13fac14d.svg";